import { ref, reactive } from 'vue';
import "ant-design-vue/es/message/style/css";
import _message from "ant-design-vue/es/message";
import "core-js/modules/es.array.push.js";
//import dayjs from 'dayjs';
import { Post, Get } from '@/api/Api';
import { ls } from 'vue-lsp';
import { ACCESS_TOKEN } from '@/store/mutation-types';
export default {
  name: 'Index',
  components: {},
  setup(props, context) {
    const RefForm = ref();
    const IsShow = ref(false);
    const DMConfig = reactive({
      FId: 0,
      Title: '',
      Width: '0',
      Height: '0',
      loading: false,
      ModelClass: '',
      Model: {},
      DMForm: {
        form: {
          labelCol: {
            style: {
              width: '160px'
            }
          }
        }
      },
      ExtendData: []
    });
    const SubmitForm = e => {
      RefForm.value.validate().then(() => {
        console.log('values11', DMConfig.Model);
        DMConfig.loading = true;
        Post("DM/SavePIPrice", DMConfig.Model).then(res => {
          if (res.succeeded) {
            _message.success('保存成功');
            context.emit('ok');
            IsShow.value = false;
          } else {
            _message.error('保存失败：' + res.errors);
            DMConfig.loading = false;
          }
        }).catch(err => {
          _message.error(err.errors);
          DMConfig.loading = false;
        });
      }).catch(error => {
        console.log(error);
        //message.error(error.message);
      });
    };

    const ResetForm = (form, DataSource) => {
      console.log('DataSource');
    };
    const OnFieldChange = e => {
      if (e.target.id == "form_item_fCustNumber") {
        Get("/DM/GetCustList", {
          CustNumber: DMConfig.Model.fCustNumber
        }).then(res => {
          DMConfig.ExtendData = res.data;
          Get("/DM/GetCust", {
            CustNumber: DMConfig.Model.fCustNumber
          }).then(res => {
            DMConfig.Model.fCustId = Number(res.data.fItemID);
            //DMConfig.Model.fCustNumber=res.data.fNumber
            DMConfig.Model.fCustName = res.data.fName;
          });
        });
      } else {
        //form_item_fNumber

        Get("/DM/GetItem", {
          Number: DMConfig.Model.fNumber
        }).then(res => {
          DMConfig.Model.fItemId = res.data.fItemID;
          //DMConfig.Model.fNumber=res.data.fNumber
          DMConfig.Model.fName = res.data.fName;
          DMConfig.Model.fModel = res.data.fModel;
        });
      }
    };
    const OnFieldChange1 = e => {
      if (e) {
        var file = DMConfig.ExtendData.find(item => item.value == e);
        if (file) {
          DMConfig.Model.fCustId = file.value;
          DMConfig.Model.fCustNumber = file.FNumber;
          DMConfig.Model.fCustName = file.label;
        } else {
          DMConfig.Model.fCustId = 0;
          DMConfig.Model.fCustNumber = '';
          DMConfig.Model.fCustName = '';
        }
      } else {
        DMConfig.Model.fCustId = 0;
        DMConfig.Model.fCustNumber = '';
        DMConfig.Model.fCustName = '';
      }
      console.log(e);
      // DMConfig.Model.fItemId=res.data.fItemID
      // //DMConfig.Model.fNumber=res.data.fNumber
      // DMConfig.Model.fName=res.data.fName
      // DMConfig.Model.fModel=res.data.fModel
    };

    const Open = (fId, width, height) => {
      IsShow.value = true;
      DMConfig.loading = true;
      DMConfig.FId = fId;
      DMConfig.Title = (fId == 0 ? '新增' : '修改') + 'PI价格';
      DMConfig.Width = width == 0 ? "100%" : width;
      DMConfig.ModelClass = width == 0 ? "full-modal" : "";
      DMConfig.Height = height == 0 ? "100%" : height;
      if (fId > 0) {
        Get("/DM/GetPIPrice1", {
          id: fId
        }).then(res => {
          DMConfig.Model = res.data;
          DMConfig.ExtendData.push({
            value: DMConfig.Model.fCustId,
            label: DMConfig.Model.fCustName,
            FNumber: DMConfig.Model.fCustNumber
          });
          DMConfig.loading = false;
        });
      } else {
        DMConfig.Model = {};
        DMConfig.loading = false;
      }
    };
    const GetExtendData = value => {
      Get("/DM/GetCustList", {
        CustNumber: value
      }).then(res => {
        DMConfig.ExtendData = res.data;
        //console.log(DMConfig.ExtendData)
      });
      // let Meta=props.Meta;
      // let LinkParentValue=DMConfig.Model[Meta.ParentFieldName];
      // GetExtendData(DMConfig.AppCode, Meta.name, value,LinkParentValue).then((res) => {
      //   if (res.Success) {
      // 	DMConfig.ExtendData[Meta.name] = res.Data
      //   } else {
      // 	message.warning(res.Message)
      //   }
      // })
    };

    return {
      IsShow,
      Open,
      RefForm,
      DMConfig,
      SubmitForm,
      ResetForm,
      OnFieldChange,
      OnFieldChange1,
      GetExtendData
    };
  },
  created() {
    console.log('created');
  },
  mounted() {},
  methods: {}
};